export const iconFontAwesomeUsersPeopleRestroom = (
	<i className="fa-solid fa-restroom"></i>
);
